import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#2AD2C8",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M39.13 25.272H10.87c0 1.95 1.699 3.533 3.65 3.533h-.118a3.533 3.533 0 0 0 3.533 3.532 3.532 3.532 0 0 0 3.533 3.533h7.065a3.532 3.532 0 0 0 3.532-3.533 3.533 3.533 0 0 0 3.533-3.533h-.118c1.951 0 3.65-1.581 3.65-3.532Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#2AD2C8",
  d: "M34.783 20.652c0 5.403-4.38 9.783-9.783 9.783s-9.782-4.38-9.782-9.783"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m32.472 20.652-3.053 1.436 1.625 2.958-3.315-.635-.42 3.35-2.31-2.464-2.309 2.463-.42-3.349-3.315.634 1.626-2.957-3.053-1.436 3.053-1.436-1.626-2.957 3.315.634.42-3.349L25 16.008l2.31-2.464.42 3.35 3.315-.635-1.626 2.957 3.053 1.436Z"
}));
FlagKZ.displayName = 'FlagKZ';
export default withFlagWrapper(FlagKZ);
//# sourceMappingURL=index.js.map